import { Address } from "viem"
import {
  TransactionItemBase,
  TransactionItemUnion,
  TransactionLabel,
} from "./baseTransactionTypes"

export type EulerSwapTransaction = {
  label: TransactionLabel.EULER_SWAP_DEPLOY_POOL | TransactionLabel.UNINSTALL
  account: Address
  subLabel?: string
}

export type EulerSwapTransactionItem = TransactionItemBase<EulerSwapTransaction>

export type DeployPoolTransaction = EulerSwapTransaction & {
  label: TransactionLabel.EULER_SWAP_DEPLOY_POOL
  enableOp1: boolean // Only use to check if the user has clicked
  vault0: Address
  vault1: Address
  equilibriumReserve0: bigint
  equilibriumReserve1: bigint
  priceX: bigint
  priceY: bigint
  concentrationX: bigint
  concentrationY: bigint
  currReserve0: bigint
  currReserve1: bigint
  fee: bigint
  protocolFee: bigint
  protocolFeeRecipient: Address
  salt: string
  transactions: TransactionItemUnion[]
  pool: Address
}

export type DeployPoolTransactionItem =
  TransactionItemBase<DeployPoolTransaction>

export type UninstallTransaction = EulerSwapTransaction & {
  label: TransactionLabel.UNINSTALL
}

export type UninstallTransactionItem = TransactionItemBase<UninstallTransaction>

export function isEulerSwapTransactionItem(
  transaction?: TransactionItemUnion,
): transaction is EulerSwapTransactionItem {
  return (
    transaction?.label === TransactionLabel.EULER_SWAP_DEPLOY_POOL ||
    transaction?.label === TransactionLabel.UNINSTALL
  )
}

export function isDeployPoolTransactionItem(
  transaction?: TransactionItemUnion,
): transaction is DeployPoolTransactionItem {
  return transaction?.label === TransactionLabel.EULER_SWAP_DEPLOY_POOL
}

export function isUninstallTransactionItem(
  transaction?: TransactionItemUnion,
): transaction is UninstallTransactionItem {
  return transaction?.label === TransactionLabel.UNINSTALL
}
